<template>
    <div class="form-group">
        <div class="d-flex justify-content-between">
            <label>{{ tra.airport_pickup }}</label>
            <span v-if="dataObj.airport && dataObj.airport.price" class="text-main-color">
                {{ dataObj.airport.price }}
                <span class="small text-dark">
                    {{ (dataObj.currency?.code || 'SAR') == 'SAR' ? ' ' : (dataObj.currency?.code || 'SAR') }}
                </span>
            </span>
        </div>
        <select 
            :value="airportId"
            @change="$emit('update-airport-id', $event.target.value)"
            class="form-control rounded-10 border" 
            data-live-search="true"
        >
            <option :value="0">{{ tra.please_select }}</option>
            <option :value="'no-airport-needed'">{{ tra.no }}</option>
            <option v-for="airport in airportsObj" :key="airport.id" :value="airport.id">
                {{ airport.name }} - {{ airport.formatedPrice }}
            </option>
        </select>
        <span v-if="postErrors.airport_id && !airportId" class="h6 text-danger">
            ( {{ postErrors.airport_id[0] }} )
        </span>
    </div>
</template>

<script>
export default {
    name: 'AirportSelector',
    props: {
        dataObj: Object,
        airportsObj: [Array, Object],
        airportId: [String, Number],
        postErrors: Object,
        tra: Object,
    },
    emits: ['update-airport-id'],
};
</script>